export default "__VITE_ASSET__B9s1jM_$__"